import * as keyapis_signal_v1_signal_pb from "./v1/keyapis_signal_signal_v1.pb";

export default {
  v1: {
    resources: {
      signal: keyapis_signal_v1_signal_pb,
    },
  },
};
